import { render, staticRenderFns } from "./index.vue?vue&type=template&id=323a0d8a&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=323a0d8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323a0d8a",
  null
  
)

export default component.exports